export const ASSIGNABLE_ROLES = ['data_curator', 'model_trainer', 'prediction_analyst', 'org_admin'];
